import { RxCollection, RxCollectionCreator, RxDocument, RxJsonSchema } from "rxdb"
import { PerformedWorkComment } from "src/util/types/dataModels/performedWork"

//region Types

export type RegularWorkItemCommentDocument = RxDocument<PerformedWorkComment>
export type RegularWorkItemCommentCollection = RxCollection<PerformedWorkComment>

//endregion

/**
 * Schema for regular work on item comment collections
 */
export const regularWorkItemCommentSchema: RxJsonSchema<PerformedWorkComment> = {
  title: "Regular Work on Item Comment schema",
  description: "Collection of all the regular work on item comments",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true },
    created_dt: { type: "string", maxLength: 64 },
    updated_dt: { type: "string", maxLength: 64 },
    text: { type: "string", maxLength: 2048 },
    user: { type: "string", maxLength: 36 },
    performed_work: { type: "string", maxLength: 36 },
    attachments: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["id", "text", "user", "performed_work"],
  indexes: ["performed_work"],
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const regularWorkItemCommentCollectionCreator: RxCollectionCreator = {
  schema: regularWorkItemCommentSchema,
}
